import { createTheme } from "@mui/material/styles";
import { plPL } from "@mui/x-date-pickers/locales";

const theme = createTheme(
	{
		typography: {
			fontSize: 12,
			fontFamily: "Calibri",
		},
		palette: {
			type: "light",
			primary: {
				main: "#63C29A",
			},
			secondary: {
				main: "#595959",
			},
			loginBox: "rgba(255, 255, 255, 0.36)",
			loginBg: "#084170",
			barColor: "#084170",
		},
		components: {
			MUIDataTableToolbar: {
				styleOverrides: {
					actions: {
						"& > button": {
							display: "none",
						},
					},
				},
			},
			MuiCssBaseline: {
				styleOverrides: {
					body: {
						"*": {
							scrollbarWidth: "thin",
						},
						scrollbarColor: "#BFBFBF #fff",
						scrollbarWidth: "thin",
						"*::-webkit-scrollbar, &::-webkit-scrollbar, & *::-webkit-scrollbar":
							{
								backgroundColor: "#fff",
								width: "4px",
								maxWidth: "4px",
							},
						"&::-webkit-scrollbar-track, & *::-webkit-scrollbar-track": {
							background:
								"linear-gradient(to right, transparent, #BFBFBFcc 2.75px, #BFBFBFcc 3.25px, transparent)",
						},
						"&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
							backgroundColor: "#BFBFBF",
							minHeight: "24px",
						},
						"&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus":
							{
								backgroundColor: "#BFBFBF",
							},
						"&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active":
							{
								backgroundColor: "#BFBFBF",
							},
						"&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover":
							{
								backgroundColor: "#BFBFBF",
							},
						"&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
							backgroundColor: "transparent",
						},
					},
				},
			},
			MuiFormControl: {
				styleOverrides: {
					root: {
						"&.phone-input": {
							"> label:not(.MuiInputLabel-shrink)": {
								paddingLeft: "76px",
							},
						},
					},
				},
			},
			// FORM LABEL
			MuiFormControlLabel: {
				styleOverrides: {
					root: ({ theme }) => ({
						"&.Mui-error": {
							color: "#d32f2f",
						},
						span: {
							fontSize: "12px",
						},
						"&.button-checkbox": {
							marginLeft: 0,
							"& > span": {
								"&:first-of-type": {
									display: "none",
								},
								"&:last-of-type": {
									background: "#BFBFBF",
									color: "#fff",
									position: "relative",
									padding: "2px 8px",
									border: "1px solid #BFBFBF",
									borderRadius: "4px",
									width: "100%",
									textAlign: "center",
								},
								"&.Mui-checked + span": {
									background: theme.palette.primary.main,
									borderColor: theme.palette.primary.main,
								},
							},
							"&.refresh-offer": {
								marginRight: "4px",
							},
						},
					}),
				},
			},
			// END FORM LABEL
			// BUTTON
			MuiButton: {
				styleOverrides: {
					root: {
						borderRadius: "4px",
						textTransform: "none",
						padding: "6px 18px",
					},
					contained: {
						color: "#fff",
						fontSize: "0.85rem",
					},
				},
			},
			// END BUTTON
			// CHECKBOX
			MuiCheckbox: {
				styleOverrides: {
					root: {
						"&:not(.Mui-checked)": {
							svg: {
								fill: "rgba(0, 0, 0, 0.23)",
							},
						},
					},
				},
			},
			// END CHECKBOX
			// DIALOG
			MuiDialog: {
				styleOverrides: {
					root: {
						"& .MuiDialog-paper": {
							boxShadow: "none !important",
							borderRadius: 0,
							borderTop: "10px solid #0069B4",
						},
					},
				},
			},
			// END DIALOG
			// TABLE
			MUIDataTable: {
				styleOverrides: {
					root: {
						boxShadow: "none !important",
					},
				},
			},
			// END TABLE
			// ACCORDION
			MuiAccordion: {
				styleOverrides: {
					root: {
						boxShadow: "none",
					},
				},
			},
			MuiAccordionSummary: {
				styleOverrides: {
					root: {
						flexDirection: "row-reverse",
					},
				},
			},
			// END ACCORDION
			// SPECIFIC
			// RADIOS
			MuiFormGroup: {
				styleOverrides: {
					root: ({ theme }) => ({
						"&.user-role-radio-group": {
							columnGap: "15px",
							rowGap: "10px",
							label: {
								marginLeft: 0,
								width: "calc(50% - 7.5px)",
								margin: 0,
								".MuiRadio-root": {
									display: "none",
									"& + span": {
										position: "relative",
										padding: "8px 0",
										border: "1px solid #ccc",
										borderRadius: "4px",
										width: "100%",
										textAlign: "center",
									},
									"&.Mui-checked + span": {
										background: "#F2F2F2",
										"&:after": {
											content: '"✓"',
											color: "green",
											position: "absolute",
											left: "17px",
											top: "50%",
											transform: "translateY(-50%)",
										},
									},
								},
							},
							"&.Mui-error": {
								label: {
									".MuiRadio-root": {
										"& + span": {
											border: "1px solid #d32f2f",
										},
									},
								},
							},
						},
						"&.radio-repeating-days": {
							width: "100%",
							justifyContent: "space-between",
							flexWrap: "nowrap",
							label: {
								width: "30%",
								marginLeft: 0,
								// width: "calc(50% - 7.5px)",
								margin: 0,
								".MuiRadio-root": {
									display: "none",
									"& + span": {
										position: "relative",
										padding: "2px 8px",
										border: "1px solid #ccc",
										borderRadius: "4px",
										width: "100%",
										textAlign: "center",
									},
									"&.Mui-checked + span": {
										background: "#d6eeff",
									},
								},
							},
						},
						"&.radio-post-after": {
							gap: "15px",
							width: "100%",
							justifyContent: "start",
							flex: "0 0 244px",
							label: {
								marginLeft: 0,
								margin: 0,
								".MuiRadio-root": {
									display: "none",
									"& + span": {
										background: "#BFBFBF",
										color: "#fff",
										position: "relative",
										padding: "2px 8px",
										border: "1px solid #BFBFBF",
										borderRadius: "4px",
										width: "100%",
										textAlign: "center",
									},
									"&.Mui-checked + span": {
										background: theme.palette.primary.main,
										borderColor: theme.palette.primary.main,
									},
								},
							},
						},
						"&.square-radio": {
							"> label": {
								"> span": {
									"input + span": {
										border: "2px solid rgba(0, 0, 0, 0.23)",
										borderRadius: "4px",
										height: "20.5667px",
										width: "20.5667px",
										svg: {
											"&:first-of-type": {
												display: "none",
											},
											"&:last-of-type": {
												height: "17.567px",
												width: "17.567px",
											},
										},
									},
								},
								"&.Mui-disabled": {
									"> span": {
										"&:first-of-type": {
											color: theme.palette.primary.main,
										},
										"&:last-of-type": {
											color: "rgba(0, 0, 0, 0.87)",
										},
									},
								},
							},
						},
					}),
				},
			},
			// END RADIOS
			MuiLinearProgress: {
				styleOverrides: {
					root: {
						"&.limit-indicator": {
							backgroundColor: "#D9D9D9",
							height: "10px",
							"> .MuiLinearProgress-bar": {
								backgroundColor: "#FFB15D",
							},
						},
					},
				},
			},
			// TABLES
			MuiPaper: {
				styleOverrides: {
					root: {
						".MuiTable-root": {
							".MuiTableHead-root": {
								".MuiTableRow-root": {
									".MuiTableCell-root": {
										padding: "6px 12px",
									},
								},
							},
						},
						"&.center-all-cells": {
							'& [class*="MUIDataTableHeadCell-contentWrapper"]': {
								justifyContent: "center",
								button: {
									margin: 0,
								},
							},
							".MuiTableCell-root": {
								textAlign: "center",
							},
						},
						"&.no-bar": {
							"> .MuiToolbar-root": {
								display: "none",
							},
						},
						"&.mui-data-table": {
							fontSize: "14px",
							"> .MuiToolbar-root": {
								padding: 0,
							},
							".MuiTable-root": {
								".MuiTableHead-root": {
									".MuiTableRow-root": {
										".MuiTableCell-root": {
											background: "#D9D9D9",
											span: {
												button: {
													background: "transparent",
													color: "#070707",
													padding: 0,
													div: {
														textTransform: "none",
														display: "flex",
														justifyContent: "center",
														alignItems: "center",
													},
												},
											},
										},
									},
								},
								".MuiTableBody-root": {
									".MuiTableRow-root": {
										".MuiTableCell-root": {
											padding: "6px 12px",
											"&:last-of-type": {
												width: "1%",
											},
										},
									},
								},
							},
						},
						"&.branches-table": {
							"> .MuiToolbar-root": {
								position: "relative",
								"> div:first-of-type": {
									position: "absolute",
									right: "0",
									width: "calc(100% - 120px - 194px)",
									maxWidth: "500px",
									"> div": {
										justifyContent: "end",
										"& > button": {
											display: "none",
										},
									},
								},
							},
						},
						"&.users-table": {
							"> .MuiToolbar-root": {
								position: "relative",
								"> div:first-of-type": {
									position: "absolute",
									right: "0",
									width: "calc(100% - 120px - 258px)",
									maxWidth: "500px",
									"> div": {
										justifyContent: "end",
										"& > button": {
											display: "none",
										},
									},
								},
							},
						},
						"&.group-table": {
							"> .MuiToolbar-root": {
								position: "relative",
								zIndex: 100,
								"> div:first-of-type": {
									position: "absolute",
									left: "430px",
									width: "calc(100% - 120px - 620px)",
									maxWidth: "500px",
									"> div": {
										justifyContent: "end",
										"& > button": {
											display: "none",
										},
									},
								},
							},
						},
						"&.import-table": {
							"> .MuiToolbar-root": {
								position: "relative",
								"> div:first-of-type": {
									position: "absolute",
									right: "0",
									width: "calc(100% - 60px - 108px)",
									maxWidth: "500px",
									"> div": {
										justifyContent: "end",
										"& > button": {
											display: "none",
										},
									},
								},
							},
							".MuiTableHead-root": {
								".MuiCheckbox-root": {
									padding: "3px",
								},
							},
							"input:not(.MuiInput-input)": {
								"&::placeholder": {
									color: "#c4c4c4",
									opacity: "1",
								},
								"&::-ms-input-placeholder": {
									color: "#c4c4c4",
								},
							},
						},
						"&.blacklist-table": {
							"> .MuiToolbar-root": {
								position: "relative",
								"> div:first-of-type": {
									position: "absolute",
									right: "0",
									width: "calc(100% - 120px - 326px)",
									maxWidth: "500px",
									"> div": {
										justifyContent: "end",
										"& > button": {
											display: "none",
										},
									},
								},
							},
						},
						"&.cargos-table": {
							"> .MuiToolbar-root": {
								position: "relative",
								"> div:first-of-type": {
									position: "absolute",
									right: "0",
									width: "calc(100% - 120px - 382px)",
									maxWidth: "500px",
									"> div": {
										justifyContent: "end",
									},
								},
							},
							"&.urgent > .MuiToolbar-root, &.sale > .MuiToolbar-root": {
								position: "relative",
								"> div:first-of-type": {
									position: "absolute",
									left: "50%",
									transform: "translateX(-50%)",
									width: "calc(100% - 120px - 382px)",
									maxWidth: "500px",
									"> div": {
										justifyContent: "end",
									},
								},
							},
							".MuiTable-root": {
								".MuiTableHead-root": {
									".MuiTableRow-root": {
										".MuiTableCell-root": {
											background: "#E2E9F1",
											padding: "3px 12px",
											'& [class*="MUIDataTableHeadCell-contentWrapper"]': {
												justifyContent: "center",
											},
											"&:first-of-type": {
												button: {
													display: "none",
												},
											},
											"&:first-of-type, &:nth-of-type(2), &:nth-of-type(3)": {
												background: "#BDE3FF",
												'& [class*="MUIDataTableHeadCell-contentWrapper"]': {
													justifyContent: "start",
												},
											},
											"&:nth-of-type(4), &:nth-of-type(5)": {
												background: "#39ACFF",
												'& [class*="MUIDataTableHeadCell-contentWrapper"]': {
													justifyContent: "start",
												},
											},
											"&:nth-last-of-type(2)": {
												background: "#C5CBD7",
												textAlign: "center",
											},
											"&:last-of-type": {
												width: "44px",
												borderBottom: "none",
												background: "#fff",
											},
											span: {
												button: {
													background: "transparent",
													color: "#070707",
													padding: 0,
													margin: 0,
													div: {
														whiteSpace: "nowrap",
														textTransform: "none",
														display: "flex",
														justifyContent: "center",
														alignItems: "center",
													},
												},
											},
										},
									},
								},
								".MuiTableBody-root": {
									".MuiTableRow-root": {
										position: "relative",
										"&.Mui-selected": {
											background: "#fffee8",
										},
										".MuiTableCell-root": {
											padding: "21px 12px",
											textAlign: "center",
											"&:first-of-type, &:nth-of-type(2), &:nth-of-type(3), &:nth-of-type(4), &:nth-of-type(5)":
												{
													textAlign: "left",
												},
											"&:first-of-type": {
												button: {
													"&.MuiIconButton-root": {
														display: "none",
													},
												},
											},
											"&:last-of-type": {
												padding: 0,
												borderBottom: "none",
												width: "unset",
											},
											"&:only-of-type": {
												display: "table-cell",
											},
										},
									},
								},
							},
						},
						"&.sold-cargos-table": {
							"> .MuiToolbar-root": {
								position: "relative",
								"> div:first-of-type": {
									position: "absolute",
									right: "0",
									width: "calc(100% - 120px - 382px)",
									maxWidth: "500px",
									"> div": {
										justifyContent: "end",
									},
								},
							},
							".MuiTable-root": {
								".MuiTableHead-root": {
									".MuiTableRow-root": {
										".MuiTableCell-root": {
											background: "#E2E9F1",
											padding: "3px 12px",
											'& [class*="MUIDataTableHeadCell-contentWrapper"]': {
												justifyContent: "center",
											},
											"&:first-of-type, &:nth-of-type(2)": {
												background: "#BDE3FF",
												'& [class*="MUIDataTableHeadCell-contentWrapper"]': {
													justifyContent: "start",
												},
											},
											"&:nth-of-type(3), &:nth-of-type(4)": {
												background: "#39ACFF",
												'& [class*="MUIDataTableHeadCell-contentWrapper"]': {
													justifyContent: "start",
												},
											},
											"&:nth-last-of-type(2)": {
												background: "#C5CBD7",
												textAlign: "center",
											},
											"&:last-of-type": {
												width: "44px",
												borderBottom: "none",
												background: "#fff",
											},
											span: {
												button: {
													background: "transparent",
													color: "#070707",
													padding: 0,
													margin: 0,
													div: {
														whiteSpace: "nowrap",
														textTransform: "none",
														display: "flex",
														justifyContent: "center",
														alignItems: "center",
													},
												},
											},
										},
									},
								},
								".MuiTableBody-root": {
									".MuiTableRow-root": {
										position: "relative",
										".MuiTableCell-root": {
											padding: "21px 12px",
											textAlign: "center",
											"&:first-of-type, &:nth-of-type(2), &:nth-of-type(3), &:nth-of-type(4)":
												{
													textAlign: "left",
												},
											"&:last-of-type": {
												padding: 0,
												borderBottom: "none",
												width: "unset",
											},
											"&:only-of-type": {
												display: "table-cell",
											},
										},
									},
								},
							},
						},
						"&.company-cargos-table": {
							"> .MuiToolbar-root": {
								position: "relative",
								"> div:first-of-type": {
									position: "absolute",
									right: "0",
									width: "calc(100% - 120px - 382px)",
									maxWidth: "500px",
									"> div": {
										justifyContent: "end",
									},
								},
							},
							".MuiTable-root": {
								".MuiTableHead-root": {
									".MuiTableRow-root": {
										".MuiTableCell-root": {
											background: "#E2E9F1",
											padding: "6px 12px",
											'& [class*="MUIDataTableHeadCell-contentWrapper"]': {
												justifyContent: "center",
											},
											"&:first-of-type, &:nth-of-type(2)": {
												background: "#BDE3FF",
												'& [class*="MUIDataTableHeadCell-contentWrapper"]': {
													justifyContent: "start",
												},
											},
											"&:nth-of-type(3), &:nth-of-type(4)": {
												background: "#39ACFF",
												'& [class*="MUIDataTableHeadCell-contentWrapper"]': {
													justifyContent: "start",
												},
											},
											"&:nth-last-of-type(1)": {
												background: "#C5CBD7",
											},
											span: {
												button: {
													background: "transparent",
													color: "#070707",
													padding: 0,
													margin: 0,
													div: {
														textTransform: "none",
														display: "flex",
														justifyContent: "center",
														alignItems: "center",
													},
												},
											},
										},
									},
								},
								".MuiTableBody-root": {
									".MuiTableRow-root": {
										position: "relative",
										".MuiTableCell-root": {
											padding: "21px 12px",
											textAlign: "center",
											"&:first-of-type, &:nth-of-type(2), &:nth-of-type(3), &:nth-of-type(4)":
												{
													textAlign: "left",
												},
										},
									},
								},
							},
						},
						"&.carrier-cargos-table": {
							".MuiTable-root": {
								".MuiTableHead-root": {
									".MuiTableRow-root": {
										".MuiTableCell-root": {
											background: "#E2E9F1",
											padding: "6px 12px",
											'& [class*="MUIDataTableHeadCell-contentWrapper"]': {
												justifyContent: "center",
												textAlign: "center",
											},
											"&:first-of-type, &:nth-of-type(2)": {
												background: "#BDE3FF",
												'& [class*="MUIDataTableHeadCell-contentWrapper"]': {
													justifyContent: "start",
												},
											},
											"&:nth-of-type(3), &:nth-of-type(4)": {
												background: "#39ACFF",
												'& [class*="MUIDataTableHeadCell-contentWrapper"]': {
													justifyContent: "start",
												},
											},
											"&:nth-last-of-type(1)": {
												background: "#C5CBD7",
												textAlign: "center",
											},
											span: {
												button: {
													background: "transparent",
													color: "#070707",
													padding: 0,
													margin: 0,
													div: {
														textTransform: "none",
														display: "flex",
														justifyContent: "center",
														alignItems: "center",
													},
												},
											},
										},
									},
								},
								".MuiTableBody-root": {
									".MuiTableRow-root": {
										position: "relative",
										".MuiTableCell-root": {
											padding: "12px",
											textAlign: "center",
											"&:first-of-type, &:nth-of-type(2), &:nth-of-type(3), &:nth-of-type(4)":
												{
													textAlign: "left",
												},
										},
									},
								},
							},
						},
						// Statistics table
						"&.statistics-table": {
							".MuiTable-root": {
								".MuiTableHead-root": {
									".MuiTableRow-root": {
										".MuiTableCell-root": {
											background: "#D9D9D9",
											span: {
												button: {
													background: "transparent",
													color: "#070707",
													padding: 0,
													div: {
														textTransform: "none",
														display: "flex",
														justifyContent: "center",
														alignItems: "center",
														whiteSpace: "nowrap",
													},
												},
											},
											"&:nth-of-type(5)": {
												span: {
													button: {
														color: "#AE78D6",
													},
												},
											},
											"&:nth-of-type(6)": {
												span: {
													button: {
														color: "#7F7F7F",
													},
												},
											},
											"&:nth-of-type(11)": {
												span: {
													button: {
														color: "#0069B4",
													},
												},
											},
											"&:nth-of-type(12)": {
												span: {
													button: {
														color: "#00B050",
													},
												},
											},
										},
									},
								},
								".MuiTableBody-root": {
									".MuiTableRow-root": {
										".MuiTableCell-root": {
											background: "transparent",
											color: "#070707",
											// padding: 0,
											"&:nth-of-type(5)": {
												color: "#AE78D6",
											},
											"&:nth-of-type(6)": {
												color: "#7F7F7F",
											},
											"&:nth-of-type(11)": {
												color: "#0069B4",
											},
											"&:nth-of-type(12)": {
												color: "#00B050",
											},
										},
									},
								},
							},
						},
					},
				},
			},
			// END TABLES
			MuiTabs: {
				styleOverrides: {
					root: {},
					scroller: {},
					list: {
						".MuiButtonBase-root": {
							border: "1px solid #F2F2F2",
							background: "#F2F2F2",
							color: "#070707",
							marginRight: "4px",
							"&.Mui-selected": {
								background: "#fff",
								color: "#070707",
							},
						},
					},
					indicator: ({ theme }) => ({
						background: theme.palette.primary.main,
						height: "6px",
					}),
				},
			},
			MuiAutocomplete: {
				styleOverrides: {
					noOptions: {
						padding: 0,
					},
					clearIndicator: {
						padding: 0,
					},
					root: {
						"&.sb-location-autocomplete": {
							".MuiAutocomplete-inputRoot": {
								paddingRight: "50px !important",
							},
						},
					},
				},
			},
			MuiList: {
				styleOverrides: {
					root: {
						".Mui-selected": {
							backgroundColor: "rgba(99, 194, 154, 0.2)",
						},
					},
					MuiMenuItem: {
						"&.Mui-selected": {
							backgroundColor: "rgba(99, 194, 154, 0.2)",
						},
					},
				},
			},
			MuiMenuItem: {
				styleOverrides: {
					root: {
						"&.Mui-selected": {
							backgroundColor: "rgba(99, 194, 154, 0.2)",
						},
					},
				},
			},
		},
	},
	plPL,
);

export default theme;
